module.exports = __webpack_public_path__ + "static/media/confirmation-cookie.0047d2cb.svg";